/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { createAction } from '../../../utils/redux-utils';
import { OperatorDetailsDto } from '../../api/operators/operatorsClient.typings';
import { Notification } from '../../../utils/utils';
import { OperatorCashBoxesStats } from '../../api/cashBoxes/cashBoxesClient.typings';

export enum OperatorAccHomePageActionType {
    OPEN_OPERATOR_ACC_HOME_PAGE = 'Operators acc home/ open page',
    EXIT_OPERATOR_ACC_HOME_PAGE = 'Operators acc home/ exit page',

    FETCH_OPERATOR_ACC_DETAILS_SUCCESS = 'Operators acc home/ fetch operator details success',
    FETCH_OPERATOR_ACC_CASHBOXES_STATS_SUCCESS = 'Operators acc home/ fetch operator cashboxes stats success',

    FETCH_OPERATOR_ACC_HOME_DATA_ERROR = 'Operators acc home/ fetch operator acc home page error',
}

export const openOperatorAccHomePageAction = () =>
    createAction(OperatorAccHomePageActionType.OPEN_OPERATOR_ACC_HOME_PAGE);

export const exitOperatorAccHomePageAction = () =>
    createAction(OperatorAccHomePageActionType.EXIT_OPERATOR_ACC_HOME_PAGE);

export const fetchOperatorAccDetailsSuccessAction = (payload: OperatorDetailsDto) =>
    createAction(OperatorAccHomePageActionType.FETCH_OPERATOR_ACC_DETAILS_SUCCESS, payload);

export const fetchOperatorAccCashboxesStatsSuccessAction = (payload: OperatorCashBoxesStats) =>
    createAction(OperatorAccHomePageActionType.FETCH_OPERATOR_ACC_CASHBOXES_STATS_SUCCESS, payload);

export const fetchOperatorAccHomeDataErrorAction = (notification: Notification) =>
    createAction(OperatorAccHomePageActionType.FETCH_OPERATOR_ACC_HOME_DATA_ERROR, { notification });

export type OperatorAccHomePageActions =
    | ReturnType<typeof openOperatorAccHomePageAction>
    | ReturnType<typeof exitOperatorAccHomePageAction>
    | ReturnType<typeof fetchOperatorAccDetailsSuccessAction>
    | ReturnType<typeof fetchOperatorAccCashboxesStatsSuccessAction>
    | ReturnType<typeof fetchOperatorAccHomeDataErrorAction>;
